import { Component, Input } from '@angular/core';

@Component({
    selector: 'fe-href-subheader',
    templateUrl: './href-subheader.component.html',
    styleUrls: ['./href-subheader.component.scss'],
})
export class HrefSubheaderComponent {
    @Input() breadcrumbs: { label: string; url: string }[] = [];
}
